<template>
    <div class="list-group-item d-flex flex-row align-items-center position-relative" @click="$emit('click')">
		<b-icon 
			v-if="showRemove"
			icon="x" 
			@click.stop="$emit('remove')" 
			class="position-absolute"
			style="cursor: pointer; top: 1rem; right: 1rem;"
		/>
        <Avatar
            class="avatar float-left mr-4 mb-3 lg:mb-0"
            :userId="session.student"
            v-if="isTeacher"
        />
        <div>
            <p class="mb-1 mt-1 font-bold" v-if="isTeacher">
                {{ session.student_displayname }}
                <template v-if="this.$config.getValue('showflagsinlist') && user">
                    <template v-if="user.flags.length">
                        <template v-for="flag in user.flags">
                            <span
                                class="userflag mr-1 mb-1"
                                :key="flag.name"
                                :class="[flag.value]"
                                >{{ flag.name }}</span
                            >
                        </template>
                    </template>
                </template>
                <span
                    class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
                    v-if="!session.isLocked"
                    >{{ $t("not-marked") }}</span
                >
                <span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="session.isLocked">{{
                    $t("marked")
                }}</span>
                <span
                    class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
                    v-if="Number(session.patientAttendance) >= 2"
                    >{{ $t("patient-did-not-attend") }}</span
                >
                <span
                    class="badge badge-pill badge-success mr-1 ml-1 mb-1"
                    v-if="session.hasPatientFeedback"
                    >{{ $t("patient-feedback") }}</span
                >
                <span
                    class="badge badge-pill badge-success mr-1 ml-1 mb-1"
                    v-if="session.studentFeedback">{{ $t("student-reflection") }}
				</span>
            </p>
            <p class="mb-1 mt-1 font-bold" v-if="!isTeacher">
				{{ $t("id-colon") }} {{ session.id }}
				<template v-if="this.$config.getValue('showflagsinlist') && user">
					<template v-if="user.flags.length">
						<template v-for="flag in user.flags">
							<span
								class="userflag mr-1 mb-1"
								:key="flag.name"
								:class="[flag.value]"
								>{{ flag.name }}</span
							>
						</template>
					</template>
				</template>
				<span
					class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
					v-if="!session.isLocked"
				>
                    {{ $t("not-marked") }}
                </span>
				<span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="session.isLocked">{{
					$t("marked")
				}}</span>
				<span
					class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
					v-if="Number(session.patientAttendance) >= 2"
                >{{ $t("patient-did-not-attend") }}</span
				>
				<span
					class="badge badge-pill badge-success mr-1 ml-1 mb-1"
					v-if="session.hasPatientFeedback"
                >{{ $t("patient-feedback") }}</span>
			</p>
            <ul class="list-bare clear-lg-none clearfix" style="overflow: hidden">
				<li class="mr-3 float-lg-left text-sm">
					<template
						v-for="participationType in this.$config.getValue('participationTypes')"
					>
						<li
							class="mr-3 float-lg-left text-sm"
							v-bind:key="participationType.id"
							v-if="participationType.id == session.typeId"
						>
							{{ participationType.name }}
							<template v-if="$config.getValue('showpatientid') && session.patient">
								({{ session.patient }})
							</template>
						</li>
					</template>
				</li>

				<li class="mr-3 float-lg-left text-sm">
					{{ session.clinicName }}
				</li>
				<li class="mr-3 float-lg-left text-sm" v-if="isTeacher">
					{{ $t("id-colon") }} {{ session.id }}
				</li>
				<li v-if="session.treatmentTimestamp" class="mr-3 float-lg-left text-sm">
					{{ 	isNaN(session.treatmentTimestamp) ? 
						session.treatmentTimestamp 
						: $datetime.getLocaleStringFromTimeStamp(session.treatmentTimestamp) }}
				</li>
				<li class="mr-3 float-lg-left text-sm">
					{{ $t("teacher-colon") }} {{ 
						session.teacher_displayname ?
						session.teacher_displayname :
						teacher_displayname
					}}
				</li>
				<li
					class="float-lg-left text-sm"
					v-if="session.chairNumber && this.$config.getValue('showchairnumber')"
				>
					{{ $t("chair-no-colon") }} {{ session.chairNumber }}
				</li>
			</ul>
        </div>
    </div>
</template>

<script>
import Avatar from "src/components/Avatar.vue"

export default {
    components: { Avatar },
    props: {
        session: Object,
		showRemove: Boolean,
    },
    mounted() {
        this.getUserDetails()
		this.$users.getDisplayName.call(this, this.session.teacher_id).then(name => {
			this.teacher_displayname = name
		})
    },
	data() {
		return {
			teacher_displayname: ''
		}
	},
    methods: {
        getUserDetails() {
			this.$users.getUserById.call(this, this.session.student).then((user) => {
				this.user = user;
			});
		},
    },
    computed: {
        isTeacher: function () {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
    }
}
</script>